import _mergeJSXProps from '@vue/babel-helper-vue-jsx-merge-props';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {createNamespace} from '../../common/utils';
import {getComponentName} from '../../common/utils/namespace';

var _createNamespace = createNamespace('col'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

var name = getComponentName('Col');

var booleanTrue = function booleanTrue(value) {
    return value !== undefined && value !== null && value !== false;
};

var Col = {
    functional: true,
    render: function render(h, configs) {
        var _b2;

        var _a, _b, _c, _d, _e;

        var data = configs.data;
        var stretch = booleanTrue(
            (_a = data === null || data === void 0 ? void 0 : data.attrs) === null || _a === void 0
                ? void 0
                : _a.stretch
        );
        var vertical =
            ((_b = data === null || data === void 0 ? void 0 : data.attrs) === null || _b === void 0
                ? void 0
                : _b.direction) === 'vertical';
        var both =
            ((_c = data === null || data === void 0 ? void 0 : data.attrs) === null || _c === void 0
                ? void 0
                : _c.direction) === 'both';
        var align =
            (_d = data === null || data === void 0 ? void 0 : data.attrs) === null || _d === void 0 ? void 0 : _d.align;
        var justify =
            (_e = data === null || data === void 0 ? void 0 : data.attrs) === null || _e === void 0
                ? void 0
                : _e.justify;
        return h(
            'div',
            _mergeJSXProps([
                {
                    class: b(
                        ((_b2 = {
                            stretch: stretch && (both || !vertical),
                            vertical: stretch && (both || vertical)
                        }),
                        _defineProperty(_b2, 'align-'.concat(align), !!align),
                        _defineProperty(_b2, 'justify-'.concat(justify), !!justify),
                        _b2)
                    )
                },
                data
            ]),
            [configs.slots().default]
        );
    }
};

Col.install = function(Vue) {
    Vue.component(name, Col);
};

Col.name = name;
export default Col;
